// replace form required asterisks with lock icons (replace with icon of choice)
$('.gform_wrapper .gfield_required').each(function () {
    $(this).html('<i class="fas fa-lock"></i>');
});


// insert dropdown icons to gform select elements
$('.gform_wrapper .ginput_container_select').each(function () {
    $(this).append('<div class="field_icon"><i class="fas fa-sort"></i></div>');
});


// insert datepicker icons to gform select elements
$('.gform_wrapper .ginput_container_date').each(function () {
    $(this).append('<div class="field_icon"><i class="far fa-calendar-alt"></i></div>');
});


// insert error icons to gform field error elements
$('.gform_wrapper .gfield.gfield_error .ginput_container:not(.ginput_container_checkbox):not(.ginput_container_radio):not(.ginput_container_select)').each(function () {
    $(this).append('<div class="error_icon"><i class="far fa-times"></i></div>');
});


// add loader and disabled class to gform submits to prevent multiple submits
$('.gform_wrapper form').submit(function (e) {
    let $submit = $(this).closest('.gform_wrapper').find('.gform_footer *[type="submit"]');

    if (!$submit.hasClass('btn-disabled')) {
        $submit.addClass('btn-disabled').prepend('<i class="icon-left fas fa-spinner fa-spin"></i>').blur();
    } else {
        e.preventDefault();
    }
});


// hide .gform_heading if .gform_description is only child and is empty
$('.gform_wrapper .gform_heading .gform_description').each(function () {
    let $heading = $(this).closest('.gform_heading');
    let $description = $(this);

    // if description is empty, hide it
    if ($description.html() === '') {
        $description.hide();

        // if description is empty, and only child, hide heading
        if ($description.siblings().size() === 0) {
            $heading.hide();
        }
    }
});



// show/hide password toggle
const classPasswordToggleToggled = 'password-toggle--toggled';

$('.password-toggle').on('click', function () {
    let $toggle = $(this),
        $icon = $toggle.find('i'),
        $input = $toggle.siblings('input'),
        originalTitle = $toggle.data('original-title'),
        originalIcon = $toggle.data('original-icon'),
        toggledTitle = $toggle.data('toggled-title'),
        toggledIcon = $toggle.data('toggled-icon');

    if ($toggle.hasClass(classPasswordToggleToggled)) {

        // reset original data
        if (typeof originalTitle !== 'undefined') {
            $toggle.attr('title', originalTitle);
        }
        if (typeof originalIcon !== 'undefined') {
            $icon.attr('class', originalIcon);
        }

        $input.attr('type', 'password');
        $toggle.removeClass(classPasswordToggleToggled);
    } else {
        let title = $toggle.attr('title'),
            icon = $icon.attr('class');

        // save original data
        $toggle.attr('data-original-title', title);
        $toggle.attr('data-original-icon', icon);

        // set toggled data
        if (typeof toggledTitle !== 'undefined') {
            $toggle.attr('title', toggledTitle);
        }
        if (typeof toggledIcon !== 'undefined') {
            $icon.attr('class', toggledIcon);
        }

        $input.attr('type', 'text');
        $toggle.addClass(classPasswordToggleToggled);
    }
});



if ($('form#register').length > 0) {
    let $form = $('form#register'),
        backend_url = $form.data('backend-url');

    // show thumbs-up animal when checking terms and privacy boxes in register form
    let $animal = $form.find('.field__animal'),
        classAnimalVisible = 'field__animal--visible',
        classFieldSuccess = 'field--success',
        classFieldError = 'field--error',
        $inputTerms = $form.find('input[name="accept_terms"]'),
        $inputPrivacy = $form.find('input[name="accept_privacy"]'),
        $fieldEmail = $form.find('.field.field--email'),
        $inputEmail = $form.find('input[name="email"]'),
        $inputEmailError = $form.find('.field--email .field__description--error-message');

    let showAnimal = function () {
        if ($inputTerms.prop('checked') === true && $inputPrivacy.prop('checked') === true && $inputEmail.data('is-checked') == 'true') {
            $animal.show();
            setTimeout(function () {
                $animal.addClass(classAnimalVisible);
            }, 10);
        } else {
            $animal.removeClass(classAnimalVisible);
        }
    }

    $form.find('input[type="checkbox"],input[name="email"]').on('change', function () {
        showAnimal();
    });

    $form.on('submit', function (e) {
        if ($inputEmail.data('is-checked') == 'false') {
            e.preventDefault();
        }
    })

    let checkEmailExists = (email) => {
        if (!email.length) {
            return;
        }

        $inputEmail.data('is-checked', 'false');

        $.post(backend_url + 'api/check-email', { 'email': email }, (response) => {

            if (response.errors.length) {
                $inputEmailError.show();
                $inputEmailError.html(response.errors[0]);
                $fieldEmail.removeClass(classFieldSuccess);
                $fieldEmail.addClass(classFieldError);

            } else {
                $inputEmailError.hide();
                $inputEmailError.html('');
                $fieldEmail.removeClass(classFieldError);
                $fieldEmail.addClass(classFieldSuccess);
                $inputEmail.data('is-checked', 'true');
            }

            showAnimal();

        });
    }

    function delay(fn, ms) {
        let timer = 0
        return function (...args) {
            clearTimeout(timer)
            timer = setTimeout(fn.bind(this, ...args), ms || 0)
        }
    }

    // check email exists after filling in e-mail
    $inputEmail.on('blur', () => {
        checkEmailExists($inputEmail.val());
    });

    $inputEmail.on('keyup', delay(() => {
        checkEmailExists($inputEmail.val());
    }, 1000));


}


